export const state = {
  showObjectSettings: false
}

export const mutations = {
  setShowObjectSettings (state, { show }) {
    state.showObjectSettings = show
  }
}

export const actions = {}

export const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
